import { STORAGE_GUARDIAN_ORIGIN_KEY } from "../constants";

export const PARTNER_QUERY_PARAM = "partner";
export const GUARDIAN_PARTNER = "guardian";
export const GUARDIAN_INTRO_FLAG = "guardian-intro";


export const isGuardianPartnerParam = (): boolean => {
  try {
    const partner = new URLSearchParams(window.location.search).get(PARTNER_QUERY_PARAM);
    return partner?.trim().toLowerCase() === GUARDIAN_PARTNER;
  } catch (error) {
    console.error("Error reading partner param:", error);
    return false;
  }
};


export const markGuardianOrigin = (): void => {
  try {
    localStorage.setItem(STORAGE_GUARDIAN_ORIGIN_KEY, "true");
  } catch (error) {
    console.error("Error storing guardian origin:", error);
  }
};

export const isGuardianOrigin = (): boolean => {
  if (isGuardianPartnerParam()) return true;
  try {
    return localStorage.getItem(STORAGE_GUARDIAN_ORIGIN_KEY) === "true";
  } catch (error) {
    console.error("Error reading guardian origin:", error);
    return false;
  }
};
